/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Subtitle_Import_Multi_Done_ToastInputs */



/**
* | output |
* | --- |
* | "Imported {count} subtitle files" |
*
* @param {Subtitle_Import_Multi_Done_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const subtitle_import_multi_done_toast = /** @type {((inputs: Subtitle_Import_Multi_Done_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subtitle_Import_Multi_Done_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`${i?.count} fichiers de sous-titres importés`)
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.count} Untertiteldateien importiert`)
	if (locale === "it") return /** @type {LocalizedString} */ (`${i?.count} file di sottotitoli importati`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Импортировано файлов субтитров: ${i?.count}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Se importaron ${i?.count} archivos de subtítulos`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`已导入 ${i?.count} 个字幕文件`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`${i?.count} 個の字幕ファイルをインポートしました`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`${i?.count} उपशीर्षक फ़ाइलें आयात की गईं`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`${i?.count} ficheiros de legendas importados`)
	return /** @type {LocalizedString} */ (`Imported ${i?.count} subtitle files`)
});